var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8149 9.93832L10.5279 18.2318C8.86121 19.8997 6.08344 19.8997 4.41677 18.2318L1.12973 14.9422C0.527882 14.3399 0.527882 13.4132 1.12973 12.8109L3.39825 10.5406C4.0001 9.93832 4.97232 9.93832 5.52788 10.5406L6.91677 11.9306C7.37973 12.3939 8.16677 12.3939 8.62973 11.9306L12.5186 8.0387C12.9816 7.57538 12.9816 6.78774 12.5186 6.32442L11.1297 4.93445C10.5279 4.33214 10.5279 3.4055 11.1297 2.80318L13.3519 0.53291C13.9538 -0.0694062 14.926 -0.0694062 15.4816 0.53291L18.8149 3.86882C20.5279 5.53677 20.5279 8.27036 18.8149 9.93832Z",
    fill: "#100E10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4444,
    height: 19.4595,
    fill: "white",
    transform: "translate(0.666748 0.0696335)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.686a244f.svg";
export { ForwardRef as ReactComponent };